import type { SpeechLabels } from '@w/content-blocks'
import type { Tel } from '@w/tel'
import type { TranslateTexts } from '../translation/page-translations'

const ENGLISH: SpeechLabels = { question: 'Question', options: 'Options', answer: 'Answer', explanation: 'Explanation', criteria: 'Criteria', hint: 'Hint' }

/** Narration labels in the listener's native language (`page-listening.spec.md` → Languages).
 * Labels are spoken content, not UI: they follow the native language, not the app locale.
 * Labels that cannot be translated are read in English; listening never fails on them. */
export async function speechLabels(native: string, translate: TranslateTexts, tel: Tel): Promise<SpeechLabels> {
  if (native.split('-')[0].toLowerCase() === 'en') return ENGLISH
  const keys = Object.keys(ENGLISH) as (keyof SpeechLabels)[]
  const translated = await translate({ texts: keys.map(key => ENGLISH[key]), target: native, format: 'text' }, tel).catch(() => [])
  return Object.fromEntries(keys.map((key, index) => [key, translated[index]?.text ?? ENGLISH[key]])) as SpeechLabels
}
